enum PayablesNewPayableWizardSteps {
    PayableDetails = "Payable Details",
    FundingAccount = "Funding Account",
    ReviewPayable = "Review Payable",
}

export default PayablesNewPayableWizardSteps;